import * as Yup from "yup";

const InventoryUploadValidationSchema = Yup.object().shape({
  inventoryUpload: Yup.string().required(
    "Please select a PDF or Excel document."
  ),
});

export default InventoryUploadValidationSchema;
